import React, { useContext, useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import * as api from "../../../utils/Api.ts";
import { InitDataContext } from "../../../context/InitDataContext.tsx";
import { Toast } from "primereact/toast";
import { appEnv, getUserIp, showMsg } from "../../../utils/Constants.tsx";
import { Navigate, useNavigate } from "react-router-dom";

interface ModalConfirmProps {
  header: string;
  text: string;
  show: boolean;
  setShowModalConfirm: any;
  setDocId: any;
  setNeedFetchingDoc: any;
  data: any;
  jsonDestination: string;
  data2: any;
  setGoHome: any;
}

export default function ModalConfirm({
  header,
  text,
  show,
  setShowModalConfirm,
  setDocId,
  setNeedFetchingDoc,
  data,
  jsonDestination,
  data2,
  setGoHome,
}: ModalConfirmProps) {
  const toast = useRef(null);

  const [visible, setVisible] = useState(show);
  const { initData, parametros } = useContext(InitDataContext);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const footerContent = (
    <div>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        onClick={() => setShowModalConfirm(false)}
        className="p-button-text base-button-noback"
      />
      <Button
        label="Envíar"
        icon="pi pi-check"
        onClick={() => sendData()}
        autoFocus
        className="base-button"
      />
    </div>
  );

  function isNumber(n: any) {
    "use strict";
    n = n.replace(/\./g, "").replace(",", ".");
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  const sendData = async () => {
    const now = new Date();

    switch (jsonDestination) {
      case "budget":
        let dataTable = data.getSourceData();
        let cleanedGridData = [];
        //TOMAMOS SOLO LAS FILAS CON DATOS (revisando los datos mismos:
        //isEmptyRow usa indices visuales y getSourceData indices fisicos)
        for (let i = 0; i < dataTable.length; i++) {
          const fila = dataTable[i] ?? [];
          if (
            fila.some(
              (v: any) =>
                v !== null && v !== undefined && String(v).trim() !== "",
            )
          ) {
            cleanedGridData.push(fila);
          }
        }

        let jsonArray = [];

        try {
          for (let i = 0; i < cleanedGridData.length; i++) {
            //OBJETO DE PRESUPUESTO ANUAL
            let obj = {
              id_centro_costo: parseInt(cleanedGridData[i][0].split("-")[0]),
              codigo_cuenta_contable: parseInt(
                cleanedGridData[i][1].split("-")[0],
              ),
              codigo_cuenta_contable_item: parseInt(
                cleanedGridData[i][2].split("-")[0],
              ),
              codigo_cuenta_contable_item_naturaleza: parseInt(
                cleanedGridData[i][3].split("-")[0],
              ),
              ano: parseInt(cleanedGridData[i][4]),
              version: 0,
              total: parseFloat(cleanedGridData[i][5]),
              observaciones: cleanedGridData[i][6],
              total_enero: parseFloat(cleanedGridData[i][7]),
              total_febrero: parseFloat(cleanedGridData[i][8]),
              total_marzo: parseFloat(cleanedGridData[i][9]),
              total_abril: parseFloat(cleanedGridData[i][10]),
              total_mayo: parseFloat(cleanedGridData[i][11]),
              total_junio: parseFloat(cleanedGridData[i][12]),
              total_julio: parseFloat(cleanedGridData[i][13]),
              total_agosto: parseFloat(cleanedGridData[i][14]),
              total_septiembre: parseFloat(cleanedGridData[i][15]),
              total_octubre: parseFloat(cleanedGridData[i][16]),
              total_noviembre: parseFloat(cleanedGridData[i][17]),
              total_diciembre: parseFloat(cleanedGridData[i][18]),
              dt_cre: new Date(),
              dt_mod: new Date(),
            };
            jsonArray.push(obj);
          }
        } catch (error) {
          console.log("Error: ", error);
          showMsg(
            toast,
            "warn",
            "Advertencia",
            "Debe completar todos los campos del presupuesto.",
          );
          setShowModalConfirm(false);
          //NO SE ENVIA UN PRESUPUESTO PARCIAL
          return;
        }

        //ENVIAMOS EL PRESUPUESTO GENERAL
        const responseBudget = await api.SEND_BUDGET.sendBudget(
          JSON.stringify(jsonArray),
        );

        if (responseBudget.length > 0) {
          alert("Presupuesto cargado correctamente.");
        } else {
          alert("Error al enviar el presupuesto");
          showMsg(toast, "error", "Error", "Error al enviar el presupuesto");
        }
        break;

      case "nvasolicitud":
        let jsonDetalleSocArray = [];
        let totalPrecioSolicitudNeto: number = 0;
        const detalles = data.detalles;

        if (isSubmitting) {
          showMsg(
            toast,
            "warning",
            "Información",
            "Ya se está enviando la solicitud, por favor espere...",
          );
          return;
        }

        try {
          setIsSubmitting(true);
          //RECORREMOS EL DETALLE DE LA SOLICITUD Y CONSTRUIMOS LOS OBJETOS PREPARADOS PARA LA BASE
          for (let i = 0; i < detalles.length; i++) {
            let objDetalleSolicitud = {
              cantidad: parseFloat(
                detalles[i].cantidad.replaceAll(".", "").replaceAll(",", "."),
              ),
              id_item: detalles[i].item,
              id_centro_costo_asociado: detalles[i].centrocosto,
              id_proveedor: detalles[i].proveedor,
              observaciones: detalles[i].detalles,
              precio_unitario_ref: parseFloat(
                detalles[i].preciorefunitario
                  .replaceAll(".", "")
                  .replaceAll(",", "."),
              ),
              precio_total_ref: parseFloat(
                detalles[i].preciorefunitariototal
                  .replaceAll(".", "")
                  .replaceAll(",", "."),
              ),
              id_estado_solicitud: 1,
              dt_cre: now,
              dt_mod: now,
              id_usuario: initData.id,
              aprobador: detalles[i].aprobador,
            };

            totalPrecioSolicitudNeto += parseFloat(
              detalles[i].preciorefunitariototal
                .replaceAll(".", "")
                .replaceAll(",", "."),
            );

            jsonDetalleSocArray.push(objDetalleSolicitud);
          }

          let objSolicitud = {
            id_sub_tipo_documento: data.tiposolicitud,
            id_usuario_solicitante: initData.id,
            id_mes_gasto: data.mesgasto,
            id_estado_operacional: data.estadooperacional,
            id_tipo_moneda: data.tipomoneda,
            url_solicitud_orden_compra_pdf: "",
            url_archivos_asociados: "",
            observaciones: data.observaciones,
            precio_total_ref: totalPrecioSolicitudNeto,
            dt_cre: now,
            dt_mod: now,
            id_estado_solicitud: 1,
          };
          //ENVIAMOS EL PRESUPUESTO GENERAL
          const responseSolicitud =
            await api.SEND_NUEVA_SOLICITUD.sendNewSolicitude(
              JSON.stringify(objSolicitud),
            );

          if (responseSolicitud.id !== null) {
            // ENVIAMOS EL DETALLE DE LA SOLICITUD JUNTO CON EL ID PADRE CREADO
            jsonDetalleSocArray = jsonDetalleSocArray.map((detalle) => ({
              ...detalle,
              id_solicitud_orden_compra: responseSolicitud.id,
            }));

            const responseSolicitudDetalle =
              await api.SEND_NUEVA_SOLICITUD_DETALLE.sendNewSolicitudeDetail(
                JSON.stringify(jsonDetalleSocArray),
              );

            if (responseSolicitudDetalle !== null) {
              let stringArrayOfCentrosCostoMail: string[] = [];
              jsonDetalleSocArray.forEach((element, index) => {
                stringArrayOfCentrosCostoMail.push(
                  //element.id_centro_costo_asociado
                  detalles[index].sdetcc_nombre,
                );
              });
              showMsg(
                toast,
                "success",
                "Éxito",
                "Solicitud enviada correctamente.",
              );

              if (appEnv === "production") {
                let paramCreaSocNt = parametros.find(
                  (param: { codigo: string }) => param.codigo === "CRESOCNT",
                )?.valor;

                if (paramCreaSocNt == 0) {
                  //ENVIAMOS MAIL DE NOTIFICACION DE INGRESO DE SOLICITUD DE ORDEN DE COMPRA
                  const responseEmailsDestinatarios =
                    await api.GET_EMAILS_DESTINATARIES_SOL.getEmailsDestinatariesSol(
                      responseSolicitud.id,
                      0,
                      "CREACION",
                    );

                  if (!responseEmailsDestinatarios.includes(initData.email)) {
                    responseEmailsDestinatarios.push(initData.email);
                  }

                  if (responseEmailsDestinatarios.length > 0) {
                    //CREACION INCLUYE NUEVA SOLICITUD, NUEVO DETALLE Y EDICION DETALLE , REMITE A:
                    //NUEVA SOL: creador y todos los jefes aprobadores involucrados
                    //EDITA SOL: creador y jefe de centro del detalle
                    //NUEVO DETALLE: creador y jefe de centro del detalle

                    let objMail = {
                      from: "noreply@salmonesdechile.com",
                      subjectEmail: `Registro de nueva solicitud de orden de compra N° ${responseSolicitud.id}`,
                      sendTo: responseEmailsDestinatarios.join(","),
                      template: "nuevaSolicitudOrdenCompra",
                      nroSolicitud: responseSolicitud.id,
                      usuario:
                        initData.nombres !== undefined
                          ? initData.nombres + " " + initData.apellido_paterno
                          : "solicitante sin nombres",
                      centroCosto: stringArrayOfCentrosCostoMail,
                    };
                    await api.POST_SEND_EMAIL_NOTIFICATION.sendNewEmail(
                      JSON.stringify(objMail),
                    );
                  }
                }
              }
              //MOSTRAR DIALOGO PARA SUBIDA DE ARCHIVOS
              setDocId(responseSolicitud.id);
              setNeedFetchingDoc(true);
            } else {
              showMsg(toast, "error", "Error", "Error al enviar la solicitud.");
            }
          }
        } catch (error) {
          console.log("Error al enviar la solicitud: ", error);
          setGoHome(true);
        }
        break;

      case "nvafirmadigital":
        //REGISTRAMOS EL NUMERO DOCUMENTO EN enrolamiento dato 1
        let objNewDigitalSign = {
          id_usuario: initData.id,
          canva: data,
          enrolamiento_dato1: data2,
        };

        const responseDigitalSign =
          await api.SEND_NUEVA_FIRMA_DIGITAL.sendNewDigitalSign(
            JSON.stringify(objNewDigitalSign),
          );

        if (responseDigitalSign.length > 0) {
          showMsg(
            toast,
            "success",
            "Éxito",
            "Firma digital registrada correctamente.",
          );
          // ENVIAMOS EL DETALLE DE LA SOLICITUD JUNTO CON EL ID PADRE CREADO
        } else {
          showMsg(toast, "error", "Error", "Error al enviar la firma digital.");
        }

        window.location.reload();

        break;

      case "editasolicitud":
        const detalleSolUpdate = data.detalles;
        let idDetailRow = 0;
        //PRIMERO RECORREMOS LOS DETALLES DE LA SOLICITUD

        idDetailRow = detalleSolUpdate[0].id;

        const objDetalleSolUpd = {
          id_solicitud_orden_compra: detalleSolUpdate[0].idsolicitudoc,
          cantidad: parseFloat(
            detalleSolUpdate[0].cantidad
              .replaceAll(".", "")
              .replaceAll(",", "."),
          ),
          id_item: detalleSolUpdate[0].item,
          id_centro_costo_asociado: detalleSolUpdate[0].centrocosto,
          id_proveedor: detalleSolUpdate[0].proveedor,
          observaciones: detalleSolUpdate[0].detalles,
          precio_unitario_ref: parseFloat(
            detalleSolUpdate[0].preciorefunitario
              .replaceAll(".", "")
              .replaceAll(",", "."),
          ).toFixed(4),
          precio_total_ref: parseFloat(
            detalleSolUpdate[0].preciorefunitariototal
              .replaceAll(".", "")
              .replaceAll(",", "."),
          ).toFixed(4),
          id_estado_solicitud: 1,
          dt_cre: now,
          dt_mod: now,
          id_usuario: initData.id,
          aprobador: detalleSolUpdate[0].aprobador,
        };

        let objUpdSolicitud = {
          id_sub_tipo_documento: data.tiposolicitud,
          id_usuario_solicitante: data.idusuariosolicitante,
          id_mes_gasto: data.mesgasto,
          id_estado_operacional: data.estadooperacional,
          id_tipo_moneda: data.tipomoneda,
          url_archivos_asociados: "",
          url_solicitud_orden_compra_pdf: "",
          observaciones: "x",
          precio_total_ref: parseFloat(
            detalleSolUpdate[0].preciorefunitariototal
              .replaceAll(".", "")
              .replaceAll(",", "."),
          ).toFixed(4),
          dt_cre: new Date(),
          dt_mod: new Date(),
          id_estado_solicitud: 1,
        };
        //ENVIAMOS EL PRESUPUESTO GENERAL
        const responseSolicitudUpdate =
          await api.PUT_UPD_SOLICITUDE.putUpdateSolicitude(
            data.id,
            JSON.stringify(objUpdSolicitud),
          );
        if (responseSolicitudUpdate.id !== null) {
          const responseSolicitudUpdateDetalle =
            await api.PUT_UPD_SOLICITUDE_DETAIL.putUpdateSolicitudeDetail(
              idDetailRow,
              JSON.stringify(objDetalleSolUpd),
            );

          if (responseSolicitudUpdateDetalle !== null) {
            let stringArrayOfCentrosCostoMailDet: string[] = [];

            stringArrayOfCentrosCostoMailDet.push(
              detalleSolUpdate[0].sdetcc_nombre,
            );
            showMsg(
              toast,
              "success",
              "Éxito",
              "Solicitud actualizada correctamente.",
            );

            if (appEnv === "production") {
              let paramEditaSocNt = parametros.find(
                (param: { codigo: string }) => param.codigo === "EDISOCNT",
              )?.valor;

              if (paramEditaSocNt == 0) {
                //ENVIAMOS MAIL DE NOTIFICACION DE INGRESO DE SOLICITUD DE ORDEN DE COMPRA
                const responseEmailsDestinatarios =
                  await api.GET_EMAILS_DESTINATARIES_SOL.getEmailsDestinatariesSol(
                    data.id,
                    idDetailRow,
                    "CREACION",
                  );

                if (responseEmailsDestinatarios.length > 0) {
                  //CREACION INCLUYE NUEVA SOLICITUD, NUEVO DETALLE Y EDICION DETALLE , REMITE A:
                  //NUEVA SOL: creador y todos los jefes aprobadores involucrados
                  //EDITA SOL: creador y jefe de centro del detalle
                  //NUEVO DETALLE: creador y jefe de centro del detalle
                  if (!responseEmailsDestinatarios.includes(initData.email)) {
                    responseEmailsDestinatarios.push(initData.email);
                  }

                  //ENVIAMOS MAIL DE NOTIFICACION DE INGRESO DE SOLICITUD DE ORDEN DE COMPRA
                  let objMailUpdateSolicitude = {
                    from: "noreply@salmonesdechile.com",
                    subjectEmail: `Se ha actualizado la solicitud de orden de compra N° ${data.id} y su detalle N° ${idDetailRow}`,
                    sendTo: responseEmailsDestinatarios.join(","),
                    template: "nuevaSolicitudOrdenCompra",
                    nroSolicitud: data.id,
                    usuario:
                      initData.nombres !== undefined
                        ? initData.nombres + " " + initData.apellido_paterno
                        : "solicitante sin nombres",
                    centroCosto: stringArrayOfCentrosCostoMailDet,
                  };
                  await api.POST_SEND_EMAIL_NOTIFICATION.sendNewEmail(
                    JSON.stringify(objMailUpdateSolicitude),
                  );
                }
              }
            }
            setNeedFetchingDoc(true);
            setGoHome(true);
            //window.location.reload();
          } else {
            showMsg(
              toast,
              "error",
              "Error",
              "Error al actualizar la solicitud.",
            );
          }
        }

        break;

      case "nvaordencompra":
        if (isSubmitting) {
          showMsg(
            toast,
            "warning",
            "Información",
            "Ya se está enviando la orden, por favor espere...",
          );
          return;
        }

        try {
          setIsSubmitting(true);

          const detallesOrden = data.detalles;

          // 1. PREPARACIÓN DE DATOS (Usando .map para ser más eficiente)
          // Extraemos nombres de centros de costo para el mail
          const stringArrayOfCentrosCostoMail = detallesOrden.map(
            (d: { sdetcc_nombre: any }) => d.sdetcc_nombre,
          );

          // Mapeamos los detalles a la estructura del DTO
          // Nota: Aún no tienen id_orden_compra, se lo ponemos después de crear la cabecera
          let jsonDetalleOrdenArray = detallesOrden.map(
            (item: {
              socdet_id: any;
              socdet_cantidad: any;
              item_id: any;
              sdetcc_id: any;
              socdet_observaciones: any;
              socdet_precio_unitario_ref: any;
              socdet_precio_total_ref: any;
            }) => ({
              id_solicitud_orden_compra_detalle: item.socdet_id,
              cantidad: item.socdet_cantidad,
              id_item: item.item_id,
              id_centro_costo_asociado: item.sdetcc_id,
              observaciones: item.socdet_observaciones,
              precio_unitario: item.socdet_precio_unitario_ref,
              precio_total: item.socdet_precio_total_ref,
              id_estado_orden: 1,
              dt_cre: now,
              dt_mod: now,
              id_usuario: initData.id,
            }),
          );

          // 2. ENVIAR CABECERA (Orden de Compra)
          let dataHeader = { ...data };
          delete dataHeader["detalles"];

          const responseOrden =
            await api.SEND_NUEVA_ORDEN_COMPRA.sendNewOrdenCompra(
              JSON.stringify(dataHeader),
            );

          // Validación crítica: Si no hay ID, detenemos todo.
          if (!responseOrden || !responseOrden.id) {
            throw new Error(
              "Error al crear la cabecera de la orden. No se recibió un ID.",
            );
          }

          // 3. ENVIAR DETALLES (Vinculados a la Cabecera)
          // Asignamos el ID padre a todos los hijos
          jsonDetalleOrdenArray = jsonDetalleOrdenArray.map((detalle: any) => ({
            ...detalle,
            id_orden_compra: responseOrden.id,
          }));

          const responseOrdenCompraDetalle =
            await api.SEND_NUEVA_ORDEN_COMPRA_DETALLE.sendNewOrdenCompraDetail(
              JSON.stringify(jsonDetalleOrdenArray),
            );

          if (!responseOrdenCompraDetalle) {
            throw new Error(
              "Se creó la orden pero falló el guardado de los detalles.",
            );
          }

          // --- PUNTO DE ÉXITO ---
          // Si llegamos aquí, la base de datos está correcta.
          showMsg(
            toast,
            "success",
            "Éxito",
            `Orden de compra N° ${responseOrden.id} generada correctamente.`,
          );

          // 4. ENVÍO DE CORREOS (Failsafe / "Fire and Forget")
          // Esto está aislado para que un error de SMTP no asuste al usuario
          if (appEnv === "production") {
            let paramCreaOcNt = parametros.find(
              (param: { codigo: string }) => param.codigo === "CREOCNT",
            )?.valor;

            if (paramCreaOcNt == 0) {
              try {
                // Obtenemos destinatarios
                const responseEmailsDestinatarios =
                  await api.GET_EMAILS_DESTINATARIES_ORD.getEmailsDestinatariesOrd(
                    responseOrden.id,
                    // Asumiendo que responseOrdenCompraDetalle devuelve un array o un objeto con id
                    Array.isArray(responseOrdenCompraDetalle)
                      ? responseOrdenCompraDetalle[0].id
                      : responseOrdenCompraDetalle.id,
                    "CREACION",
                  );

                if (
                  responseEmailsDestinatarios &&
                  responseEmailsDestinatarios.length > 0
                ) {
                  // Asegurar que el creador esté en la lista
                  if (!responseEmailsDestinatarios.includes(initData.email)) {
                    responseEmailsDestinatarios.push(initData.email);
                  }

                  const objMail = {
                    from: "noreply@salmonesdechile.com",
                    subjectEmail: `Registro de nueva orden de compra N° ${responseOrden.id}`,
                    sendTo: responseEmailsDestinatarios.join(","),
                    template: "nuevaOrdenCompra",
                    nroOrden: responseOrden.id,
                    usuario: initData.nombres
                      ? `${initData.nombres} ${initData.apellido_paterno}`
                      : "Usuario Sistema",
                    centroCosto: stringArrayOfCentrosCostoMail,
                  };

                  await api.POST_SEND_EMAIL_NOTIFICATION.sendNewEmail(
                    JSON.stringify(objMail),
                  );
                }
              } catch (mailError) {
                // Solo logueamos el error, NO lanzamos excepción para no bloquear la redirección
                console.warn(
                  "La orden se creó, pero hubo un error enviando el correo:",
                  mailError,
                );
                // Opcional: Mostrar un toast warning suave
                // showMsg(toast, "warn", "Aviso", "Orden creada, pero el correo de notificación no pudo enviarse.");
              }
            }
          }
          // 5. REDIRECCIÓN FINAL
          setNeedFetchingDoc(true);
          setGoHome(true);
        } catch (error) {
          // MANEJO DE ERRORES PRINCIPAL
          console.error("Error crítico en nvaordencompra:", error);

          // Intentamos extraer un mensaje legible del backend si existe
          const serverMessage = (error as any).response?.data?.message;
          const userMessage = serverMessage
            ? Array.isArray(serverMessage)
              ? serverMessage.join(", ")
              : serverMessage
            : (error as any).message ||
              "Error desconocido al procesar la solicitud.";

          showMsg(toast, "error", "Error", userMessage);
        } finally {
          setIsSubmitting(false);
        }
        break;

      case "editaordencompra":
        const detalleOcUpdate = data.detalles;
        let idDetailOcRow = 0;
        //PRIMERO RECORREMOS LOS DETALLES DE LA SOLICITUD

        idDetailOcRow = detalleOcUpdate[0].id;

        const objDetalleOcUpd = {
          id_orden_compra: detalleOcUpdate[0].idoc,
          id_solicitud_orden_compra_detalle: detalleOcUpdate[0].id,
          cantidad: parseFloat(
            detalleOcUpdate[0].cantidad
              .replaceAll(".", "")
              .replaceAll(",", "."),
          ),
          id_item: detalleOcUpdate[0].item,
          id_centro_costo_asociado: detalleOcUpdate[0].centrocosto,
          observaciones: detalleOcUpdate[0].detalles,
          precio_unitario: parseFloat(
            detalleOcUpdate[0].preciounitario
              .replaceAll(".", "")
              .replaceAll(",", "."),
          ).toFixed(4),
          precio_total: parseFloat(
            detalleOcUpdate[0].preciounitariototal
              .replaceAll(".", "")
              .replaceAll(",", "."),
          ).toFixed(4),
          id_estado_orden: 1,
          dt_cre: now,
          dt_mod: now,
          id_usuario: initData.id,
        };

        let objUpdOrdenCompra = {
          id_sub_tipo_documento: data.tiposolicitud,
          id_usuario_solicitante: data.idusuariosolicitante,
          id_mes_gasto: data.mesgasto,
          id_estado_operacional: data.estadooperacional,
          id_tipo_moneda: data.tipomoneda,
          id_proveedor: data.idproveedor,
          url_orden_compra_pdf: "",
          url_archivos_asociados_pdf: "",
          observaciones: "x",
          tipo_cambio_dia: data.tipocambiodia,
          id_estado_orden: 1,
          id_tipo_doc_tributario: data.idtipodoctributario,
          dt_cre: new Date(),
          dt_mod: new Date(),
          condicion_pago: data.condicionPago,
        };

        //ENVIAMOS EL PRESUPUESTO GENERAL
        const responseOrdenCompraUpdate =
          await api.PUT_UPD_ORDEN_COMPRA.putUpdateOrdenCompra(
            data.id,
            JSON.stringify(objUpdOrdenCompra),
          );
        if (responseOrdenCompraUpdate.id !== null) {
          const responseOrdenCompraUpdateDetalle =
            await api.PUT_UPD_ORDEN_COMPRA_DETAIL.putUpdateOrdenCompraDetail(
              idDetailOcRow,
              JSON.stringify(objDetalleOcUpd),
            );

          if (responseOrdenCompraUpdateDetalle !== null) {
            let stringArrayOfCentrosCostoMailDet: string[] = [];

            /* stringArrayOfCentrosCostoMailDet.push(
              objDetalleOcUpd.id_centro_costo_asociado
            );*/

            stringArrayOfCentrosCostoMailDet.push(
              detalleOcUpdate[0].sdetcc_nombre,
            );

            if (appEnv === "production") {
              let paramEditaOcNt = parametros.find(
                (param: { codigo: string }) => param.codigo === "EDIOCNT",
              )?.valor;

              if (paramEditaOcNt == 0) {
                //ENVIAMOS MAIL DE NOTIFICACION DE INGRESO DE SOLICITUD DE ORDEN DE COMPRA
                const responseEmailsDestinatarios =
                  await api.GET_EMAILS_DESTINATARIES_ORD.getEmailsDestinatariesOrd(
                    data.id,
                    idDetailOcRow,
                    "CREACION",
                  );

                if (responseEmailsDestinatarios.length > 0) {
                  //CREACION INCLUYE NUEVA SOLICITUD, NUEVO DETALLE Y EDICION DETALLE , REMITE A:
                  //NUEVA SOL: creador y todos los jefes aprobadores involucrados
                  //EDITA SOL: creador y jefe de centro del detalle
                  //NUEVO DETALLE: creador y jefe de centro del detalle

                  if (!responseEmailsDestinatarios.includes(initData.email)) {
                    responseEmailsDestinatarios.push(initData.email);
                  }

                  //ENVIAMOS MAIL DE NOTIFICACION DE INGRESO DE SOLICITUD DE ORDEN DE COMPRA
                  let objMailUpdateOrdenCompra = {
                    from: "noreply@salmonesdechile.com",
                    subjectEmail: `Se ha actualizado la orden de compra N° ${data.id} y su detalle N° ${idDetailOcRow}`,
                    sendTo: responseEmailsDestinatarios.join(","),
                    template: "editaOrdenCompra",
                    nroOrden: data.id,
                    usuario:
                      initData.nombres !== undefined
                        ? initData.nombres + " " + initData.apellido_paterno
                        : "solicitante sin nombres",
                    centroCosto: stringArrayOfCentrosCostoMailDet,
                  };
                  await api.POST_SEND_EMAIL_NOTIFICATION.sendNewEmail(
                    JSON.stringify(objMailUpdateOrdenCompra),
                  ).then(() => {
                    //window.location.reload();
                    setGoHome(true);
                  });
                }
              } else {
                setGoHome(true);
              }
            }
            showMsg(
              toast,
              "info",
              "Info",
              "Orden de compra actualizada correctamente.",
            );
            //window.location.reload();
          } else {
            showMsg(
              toast,
              "error",
              "Error",
              "Error al actualizar la orden de compra.",
            );
          }
        }
        break;

      case "nvodetallesolicitud":
        let jsonNvoDetalleSocArray = [];

        let objDetalleSolicitud = {
          id_solicitud_orden_compra: data.idsolicitudoc,
          cantidad: parseFloat(
            data.cantidad.replaceAll(".", "").replaceAll(",", "."),
          ),
          id_item: data.item,
          id_centro_costo_asociado: data.centrocosto,
          id_proveedor: data.proveedor,
          observaciones: data.detalles,
          precio_unitario_ref: parseFloat(
            data.preciorefunitario.replaceAll(".", "").replaceAll(",", "."),
          ),
          precio_total_ref: parseFloat(
            data.preciorefunitariototal
              .replaceAll(".", "")
              .replaceAll(",", "."),
          ),
          id_estado_solicitud: 1,
          dt_cre: now,
          dt_mod: now,
          id_usuario: initData.id,
          aprobador: data.aprobador,
        };

        jsonNvoDetalleSocArray.push(objDetalleSolicitud);

        const responseNvoSolicitudDetalle =
          await api.SEND_NUEVA_SOLICITUD_DETALLE.sendNewSolicitudeDetail(
            JSON.stringify(jsonNvoDetalleSocArray),
          );

        if (responseNvoSolicitudDetalle[0] !== null) {
          let stringArrayOfCentrosCostoMail: string[] = [];
          jsonNvoDetalleSocArray.forEach((element) => {
            stringArrayOfCentrosCostoMail.push(
              element.id_centro_costo_asociado,
            );
          });

          if (appEnv === "production") {
            let paramNvoDetalleSOcNt = parametros.find(
              (param: { codigo: string }) => param.codigo === "DETSOCNT",
            )?.valor;

            if (paramNvoDetalleSOcNt == 0) {
              //ENVIAMOS MAIL DE NOTIFICACION DE INGRESO DE SOLICITUD DE ORDEN DE COMPRA
              const responseEmailsDestinatarios =
                await api.GET_EMAILS_DESTINATARIES_SOL.getEmailsDestinatariesSol(
                  data.idsolicitudoc,
                  responseNvoSolicitudDetalle[0].sdetcc_nombre,
                  "CREACION",
                );

              if (responseEmailsDestinatarios.length > 0) {
                //CREACION INCLUYE NUEVA SOLICITUD, NUEVO DETALLE Y EDICION DETALLE , REMITE A:
                //NUEVA SOL: creador y todos los jefes aprobadores involucrados
                //EDITA SOL: creador y jefe de centro del detalle
                //NUEVO DETALLE: creador y jefe de centro del detalle

                if (!responseEmailsDestinatarios.includes(initData.email)) {
                  responseEmailsDestinatarios.push(initData.email);
                }

                //ENVIAMOS MAIL DE NOTIFICACION DE INGRESO DE SOLICITUD DE ORDEN DE COMPRA
                let objMail = {
                  from: "noreply@salmonesdechile.com",
                  subjectEmail: `Registro de nuevo detalle N° ${responseNvoSolicitudDetalle[0].id} en solicitud de orden de compra N° ${data.idsolicitudoc}`,
                  sendTo: responseEmailsDestinatarios.join(","),
                  template: "nuevaSolicitudOrdenCompra",
                  nroSolicitud: data.idsolicitudoc,
                  usuario:
                    initData.nombres !== undefined
                      ? initData.nombres + " " + initData.apellido_paterno
                      : "solicitante sin nombres",
                  centroCosto: stringArrayOfCentrosCostoMail,
                };
                await api.POST_SEND_EMAIL_NOTIFICATION.sendNewEmail(
                  JSON.stringify(objMail),
                );
              }
            }
          }

          setShowModalConfirm(false);
          setNeedFetchingDoc(true);
          setGoHome(true);

          showMsg(
            toast,
            "success",
            "Éxito",
            "Detalle de solicitud enviada correctamente.",
          );
        } else {
          setShowModalConfirm(false);

          showMsg(
            toast,
            "error",
            "Error",
            "Error al enviar el nuevo detalle de la solicitud.",
          );
        }

        break;

      case "default":
        null;
        break;
    }

    setShowModalConfirm(false);
  };

  return (
    <div className="card flex justify-content-center">
      <Dialog
        header={header}
        visible={show}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!visible) return;
          setShowModalConfirm(false);
        }}
        footer={footerContent}
      >
        <Toast ref={toast} />
        <p className="m-0">{text}</p>
      </Dialog>
    </div>
  );
}
